import * as React from "react";
import { PINResetForm } from "./PINResetForm";
import { OBRSettingsProvider } from "./OBRSettings";
import { useSearchParams } from "react-router-dom";
import { useDialog } from "@tlc/ui/dialog/useDialog";

export const PINResetPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const borrowerNumberParam = searchParams.get("borrowerNumber");
  const borrowerNumber = borrowerNumberParam
    ? parseInt(borrowerNumberParam)
    : undefined;
  const verificationCode = searchParams.get("verificationCode") ?? "";
  const { open, openDialog, closeDialog } = useDialog();

  React.useEffect(() => {
    openDialog();
  }, [openDialog]);

  return (
    <OBRSettingsProvider>
      <PINResetForm
        open={open}
        onClose={closeDialog}
        borrowerNumber={borrowerNumber}
        verificationCode={verificationCode}
      ></PINResetForm>
    </OBRSettingsProvider>
  );
};
